import createSagaMiddleware from "redux-saga";
import rootSaga from "redux/sagas";
import { createBrowserHistory } from "history";
import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from "redux-first-history";
import rootReducer from './reducers';
import { filesApi } from "./reducers/filesApi";

export const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const preloadedState = {};
const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    middleware: getDefaultMiddleware => [
      ...getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }),
      routerMiddleware,
      sagaMiddleware,
      filesApi.middleware,
    ],
    reducer: rootReducer(routerReducer),
    preloadedState,
  });
  sagaMiddleware.run(rootSaga);
  return store;
};

export default createStore;
